module.exports = __webpack_public_path__ + "img/003-instagram.009ef790.png";